import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import VerticalLayout from '@/layouts/index';
import AuthLayout from '@/layouts/AuthLayout';

import { authRoutes, authProtectedRoutes, publicRoutes } from './routes-path';
import MfAGuard from '@/features/auth/components/MfAGuard';

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* Authentication routes (login/logout) - no auth required */}
        {authRoutes.map((route: { path: string | undefined; component: any }, idx: React.Key | null | undefined) => (
          <Route path={route.path} element={<AuthLayout>{route.component}</AuthLayout>} key={idx} />
        ))}
        {publicRoutes.map((route: { path: string | undefined; component: any }, idx: React.Key | null | undefined) => (
          <Route path={route.path} element={<VerticalLayout>{route.component}</VerticalLayout>} key={idx} />
        ))}
        <Route element={<MfAGuard />}>
          {authProtectedRoutes.map(
            (route: { path: string | undefined; component: any }, idx: React.Key | null | undefined) => (
              <Route path={route.path} element={<VerticalLayout>{route.component}</VerticalLayout>} key={idx} />
            ),
          )}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
